import type { TealiumDataLayer } from "./types";

export function setTealiumData(data: TealiumDataLayer) {
  if (typeof window === "undefined") return;

  const win = window as Window & { utag_data?: TealiumDataLayer };
  win.utag_data = { ...win.utag_data, ...data };
}
